import { getBaseInputStyles } from './helpers/get-base-input-styles'
import { cn } from '@lib/cn'
import React, { FC, InputHTMLAttributes } from 'react'

export type InputHasErrorProp = {
  hasError?: boolean
}

export type InputSizeVariantProp = {
  variant?: 'regular' | 'small'
}

export type InputProps = InputHasErrorProp &
  InputSizeVariantProp &
  InputHTMLAttributes<HTMLInputElement> & {
    className?: string
  }

export const Input: FC<InputProps> = ({ className, hasError, variant, ...rest }) => {
  const baseInputStyle = getBaseInputStyles(hasError)
  return (
    <input
      className={cn(
        baseInputStyle,
        'rolex-input-labels-transform',
        variant === 'small' ? 'leading-[1.5rem]' : 'leading-[2rem]',
        className,
      )}
      {...rest}
    />
  )
}
